<section class="centered-with-padding">
  <app-title [title]="data.title" size="custom-30" />
  <div class="mt-2 flex gap-x-1.5">
    <span>{{ "GLOBAL.BUDGET" | translate }}</span>
    <span class="flex gap-x-0.5">
      @for (i of data.costLevel | generateRange; track i) {
        <app-svg [height]="21" [width]="21" src="assets/icons/badge-price.svg" />
      }
    </span>
  </div>
</section>
